import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=448c84cb&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=448c84cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c84cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('448c84cb')) {
      api.createRecord('448c84cb', component.options)
    } else {
      api.reload('448c84cb', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=448c84cb&scoped=true", function () {
      api.rerender('448c84cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/utility/Chat.vue"
export default component.exports